import { Button } from '../primitives/button';

export interface ListPaginationProps {
  offset: number;
  itemCount: number;
  total: number;
  hasMore: boolean;
  onPrevious: () => void;
  onNext: () => void;
  formatNumber?: (n: number) => string;
}

export function ListPagination({
  offset,
  itemCount,
  total,
  hasMore,
  onPrevious,
  onNext,
  formatNumber = String,
}: ListPaginationProps) {
  const start = offset + 1;
  const end = Math.min(offset + itemCount, total);

  return (
    <div className="flex flex-col gap-3 border-t border-border px-4 py-3 text-sm tabular-nums text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
      <div>
        Showing {start}-{end} of {formatNumber(total)}
      </div>
      <div className="flex gap-3">
        <Button
          type="button"
          variant="secondary"
          disabled={offset === 0}
          onClick={onPrevious}
        >
          Previous
        </Button>
        <Button
          type="button"
          variant="secondary"
          disabled={!hasMore}
          onClick={onNext}
        >
          Next
        </Button>
      </div>
    </div>
  );
}
